import { YMaps } from '@pbe/react-yandex-maps';
import React, { type PropsWithChildren } from 'react';

export { VanillaMapContainer as PickupPointsMap } from './VanillaMapContainer';

export function PickupPointsMapProvider({
  children,
  yandexApiKey,
}: PropsWithChildren<{
  yandexApiKey?: string;
}>) {
  return (
    <YMaps query={{ apikey: yandexApiKey, load: 'util.bounds' }} preload>
      {children}
    </YMaps>
  );
}
